import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  loaderWrap: {
    zIndex: 1001,
  },
});

const defaultProps = {
  loading: false,
};

type Props = {
  children?: React.ReactNode;
} & typeof defaultProps;

export default function Loading(props: Props) {
  const classes = useStyles();
  const { loading } = props;
  return <>{loading && <LinearProgress className={classes.loaderWrap} />}</>;
}

Loading.defaultProps = defaultProps;
